<template>
    <div
        class="checkbox group relative flex w-full items-center justify-start gap-4"
        :class="class"
    >
        <template v-if="checkboxPosition === 'right'">
            <input
                :id="name"
                type="checkbox"
                :value="value"
                :name="name"
                class="hidden"
                :checked="checked"
                @change="checkedChanged"
            />
            <label
                :for="name"
                class="w-full justify-between text-body-medium-button"
            >
                <div class="flex w-full flex-col">
                    <div class="flex w-full items-center justify-between">
                        <div class="label">
                            <div class="flex items-center gap-3">
                                <template v-if="icon">
                                    <v-icon
                                        :icon="icon"
                                        size="4"
                                        :class="classIcon"
                                    ></v-icon>
                                </template>
                                <div :class="classLabel" v-html="label"></div>
                            </div>
                        </div>
                        <div class="icon">
                            <v-icon icon="checkbox"></v-icon>
                        </div>
                    </div>
                    <div
                        class="description text-body-regular text-black-40 max-lg:mt-3 lg:pr-16"
                        v-html="description"
                    ></div>
                </div>
            </label>
        </template>
        <template v-else>
            <template v-if="inputName">
                <figure class="flex w-full flex-col gap-[10px]">
                    <div
                        class="relative flex w-full items-center justify-start gap-4"
                    >
                        <input
                            :id="name"
                            type="checkbox"
                            :value="value"
                            :name="name"
                            class="hidden"
                            :checked="checked"
                            @change="checkedChanged"
                        />
                        <label
                            :for="name"
                            class="flex w-full flex-col justify-start gap-[10px] text-body-medium-button"
                        >
                            <div class="label w-full">
                                <div class="flex items-center gap-3">
                                    <template v-if="icon">
                                        <v-icon
                                            :icon="icon"
                                            :size="iconSize ?? 4"
                                        ></v-icon>
                                    </template>
                                    <div v-html="label"></div>
                                </div>
                            </div>
                            <div
                                class="flex min-h-[49px] w-full items-center gap-4"
                            >
                                <div class="icon">
                                    <v-icon icon="checkbox"></v-icon>
                                </div>
                                <div
                                    class="input group relative flex hidden w-full flex-col gap-[10px]"
                                >
                                    <input
                                        :id="inputName"
                                        :type="inputType"
                                        :value="value"
                                        :name="inputName"
                                        :placeholder="inputPlaceholder"
                                        :checked="checked"
                                    />
                                </div>
                            </div>
                        </label>
                    </div>
                </figure>
            </template>
            <template v-else>
                <input
                    :id="id ?? name"
                    type="checkbox"
                    :value="value"
                    :name="name"
                    class="hidden"
                    :checked="checked"
                    @change="checkedChanged"
                />
                <label
                    :for="id ?? name"
                    class="w-full justify-start gap-4 text-body-medium-button"
                >
                    <div class="icon">
                        <v-icon icon="checkbox"></v-icon>
                    </div>
                    <div class="label">
                        <div class="flex items-center gap-3">
                            <template v-if="icon">
                                <v-icon
                                    :icon="icon"
                                    :size="iconSize ?? 4"
                                ></v-icon>
                            </template>
                            <div v-html="label"></div>
                        </div>
                    </div>
                </label>
            </template>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        class: {
            type: String,
        },
        required: {
            type: Boolean,
        },
        name: {
            type: String,
        },
        model: {
            type: String,
        },
        label: {
            type: String,
        },
        classLabel: {
            type: String,
        },
        classIcon: {
            type: String,
        },
        description: {
            type: String,
        },
        checkboxPosition: {
            type: String,
        },
        inputName: {
            type: String,
        },
        inputPlaceholder: {
            type: String,
        },
        inputType: {
            type: String,
        },
        icon: {
            type: String,
        },
        iconSize: {
            type: Number,
            default: 4,
        },
        value: {
            type: [Number, String],
            required: false,
            default: "1",
        },
        checked: {
            type: Boolean,
            required: false,
            default: false,
        },
        id: {
            type: String,
            required: false,
            deafult: null,
        },
    },
    data() {
        return {
            show: false,
        };
    },
    methods: {
        checkedChanged(event) {
            this.$emit('checkchange', event.target.checked);
            this.$emit('vchanged', this.value)
        }
    }
};
</script>
